import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { DateHeaderCapStyled, CapSeparator } from './styles/DailyProgramStyled';

class DateHeaderCap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHidden: props.isHidden,
    };
  }

  componentDidMount() {
    const { onInstance } = this.props;
    if (_.isFunction(onInstance)) {
      onInstance(this);
    }
  }

  componentWillUnmount() {
    const { onInstance } = this.props;
    if (_.isFunction(onInstance)) {
      onInstance(null);
    }
  }

  setIsHidden = (value) => {
    if (this.state.isHidden !== value) {
      this.setState({
        isHidden: value,
      });
    }
  };

  render() {
    const { day, style, month, isHidden } = this.props;
    return (
      <DateHeaderCapStyled
        isHidden={isHidden}
        data-name="headerCap"
        data-day={day}
        data-month={month}
        style={style}
      >
        <CapSeparator />
      </DateHeaderCapStyled>
    );
  }
}

DateHeaderCap.propTypes = {
  isHidden: PropTypes.bool.isRequired,
  day: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  onInstance: PropTypes.func,
};

DateHeaderCap.defaultProps = {
  onInstance: undefined,
};

export default DateHeaderCap;
